'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var XCircleFilled = require('../../components/Icon/XCircleFilled.js');
var StylelessButton = require('../../components/StylelessButotn/StylelessButton.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Thumbnail = require('@narvar/nth-bit-thumbnail');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var Thumbnail__default = /*#__PURE__*/_interopDefaultLegacy(Thumbnail);

const PhotosWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-1d1spgo-0"
})(["display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;width:100%;gap:1rem;"]);
const Photo = styled__default["default"].div.withConfig({
  componentId: "sc-1d1spgo-1"
})(["position:relative;"]);
const ItemPhotosList = _ref => {
  let {
    photos,
    onRemovePhoto
  } = _ref;
  const {
    claimsPhotoUploadRemoveButtonLabel
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement(PhotosWrapper, null, photos.map((photo, index) => /*#__PURE__*/React__default["default"].createElement(Photo, {
    key: photo.file.name,
    "data-testid": `photo-${photo.file.name}`
  }, /*#__PURE__*/React__default["default"].createElement(StylelessButton.StylelessButton, {
    "aria-label": claimsPhotoUploadRemoveButtonLabel || '',
    onClick: () => {
      onRemovePhoto(index);
    },
    style: {
      position: 'absolute',
      padding: '0.25rem',
      top: '0.25rem',
      right: '0.25rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement(XCircleFilled["default"], null)), /*#__PURE__*/React__default["default"].createElement(Thumbnail__default["default"], {
    alt: photo.file.name,
    src: photo.objectUrl,
    s: {
      width: '9.375rem',
      margin: 'auto'
    }
  }))));
};
var ItemPhotosList$1 = nthHookTranslations.withTranslationsProvider(ItemPhotosList, {
  translationKeys: ['claimsPhotoUploadRemoveButtonLabel']
});

exports["default"] = ItemPhotosList$1;
